module.exports = __webpack_public_path__ + "media/site/images/case_studies/eplanning/planning1@2x-b28d22b57481e763c195cae875d64396.png";